import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { setCurrentSelection } from '../actions';
import Scoreboard from '../Scoreboard';
import { makeGetSelectionData } from '../selectors';
import { noScoreboards } from '../unsupportedSports';
import EventConnect from './Event';

export class Selection extends React.Component {
  constructor() {
    super();
    this.toggle = this.toggle.bind(this);
  }

  componentWillUnmount() {
    this.props.setCurrentSelection('');
    this.props.setInPlay(false);
    this.props.setIsSettled(false);
    this.props.setQualifyingFreeBet(true);
    this.props.setQueryBetCalled(false);
  }

  componentDidUpdate() {
    if (this.props.eventInPlay === true) {
      this.props.setInPlay(true);
    }
    if (this.props.selectionResult !== '') {
      this.props.setIsSettled(true);
    }
  }

  toggle() {
    const {
      selectionUniqueId,
      selectionExpanded
    } = this.props;

    const setId = selectionExpanded ? '' : selectionUniqueId;
    this.props.setCurrentSelection(setId);
  }

  render() {
    const {
      selectionUniqueId,
      selectionLabel,
      selectionResult,
      selectionExpanded,
      eventId,
      eventInPlay,
      marketName,
      scoreboardUrl,
      sport,
      setInPlay,
      setIsSettled
    } = this.props;

    if (eventInPlay === true) {
      setInPlay(true);
    }

    if (selectionResult !== '') {
      setIsSettled(true);
    }

    const scoreboardSupport = !noScoreboards.includes(sport);

    return (
      <div className="open-bet-selection">
        <div className="open-bet-selection__card">
          <div className="open-bet-selection__header">
            <div className="open-bet-selection__stats-cell">
              {
                (scoreboardSupport && (eventInPlay || selectionExpanded))
                  ? (
                    <div className="open-bet-selection__stats-toggle" onClick={this.toggle}>
                      Stats
                    </div>
                  )
                  : null
              }
            </div>
            <div className="open-bet-selection__label-cell">
              <div className="open-bet-selection__label">
                {selectionLabel.replace(new RegExp('\\?(?=\\d)'), '£')}
              </div>
            </div>
            <div className="open-bet-selection__badge-cell">
              {
                selectionResult
                  ? (
                    <div
                      className={classnames('selection-result-badge',
                        { 'selection-result-badge--won': selectionResult === 'Win' })}
                    >
                      {selectionResult}
                    </div>
                  )
                  : null
              }
            </div>
          </div>
          <div className="open-bet-selection__market-name">
            {marketName}
          </div>
          {
            scoreboardSupport && selectionExpanded
              ? (
                <div className="open-bet-selection__scoreboard">
                  <Scoreboard url={scoreboardUrl} id={selectionUniqueId} sportName={sport} />
                </div>
              )
              : (
                <EventConnect eventId={eventId} />
              )
          }
        </div>
      </div>
    );
  }
}

Selection.propTypes = {
  selectionUniqueId: PropTypes.string.isRequired,
  selectionLabel: PropTypes.string.isRequired,
  selectionResult: PropTypes.string,
  selectionExpanded: PropTypes.bool,
  eventId: PropTypes.string.isRequired,
  eventInPlay: PropTypes.bool.isRequired,
  marketName: PropTypes.string.isRequired,
  scoreboardUrl: PropTypes.string.isRequired,
  sport: PropTypes.string.isRequired,
  setCurrentSelection: PropTypes.func.isRequired,
  setInPlay: PropTypes.func,
  setIsSettled: PropTypes.func,
  setQualifyingFreeBet: PropTypes.func,
  setQueryBetCalled: PropTypes.func
};

const makeMapStateToProps = (initialState, initialProps) => {
  const getSelectionData = makeGetSelectionData();
  return (state) => ({
    ...getSelectionData(state, initialProps)
  });
};

const mapDispatchToProps = {
  setCurrentSelection
};

export default connect(makeMapStateToProps, mapDispatchToProps)(Selection);
